// Port of api/fuel/app/classes/filter/search/games/filters/query/comment/text.php
import Rule from 'offline/filter/core/search/rule'

export default {
	name: 'comment.text',
	priority: 82,
	require: function(config, filter) { return filter.comment && filter.comment.text && filter.comment.text.length > 0 },
	run: function(config, filter, data, query) {
		var keywords = Rule.getKeywords(filter.comment.text)
		for (var i = 0; i < keywords.length; i++) {
			query.where('m.comment_text', 'like', '%' + keywords[i] + '%')
		}
	}
}
